<form [formGroup]="patientCallQuestionsAnswersForm">
  <ion-list scrollY="true" lines="none" class="patient-call-question-list" formArrayName="patientCallQuestionsAnswers">
    <div *ngFor="let question of questions; let idx = index" formGroupName="{{ idx }}">
      <ion-item *ngIf="question.patientQuestionTypeLabel == 'boolean'" class="call-question boolean-call-question ion-text-center">
        <div class="call-question-body-container">
          <div class="call-question boolean-question-layout">
            <ng-container>
              <span class="patient-call-question-label" [id]="'patient-call-question-' + idx">
                {{ question.patientCallQuestion }}
              </span>
              <div
                class="boolean-question-group"
                [attr.aria-labelledby]="'patient-call-question-' + idx"
              >
                <ion-checkbox
                  class="boolean-option followup-form-choice followup-form-choice--compact"
                  [checked]="isBooleanAnswer(idx, question.patientCallQuestionId, 'true')"
                  (ionChange)="onBooleanAnswerChange(idx, question.patientCallQuestionId, 'true', $event.detail.checked)"
                  labelPlacement="end"
                  alignment="center"
                  justify="start"
                >
                  Yes
                </ion-checkbox>
                <ion-checkbox
                  class="boolean-option followup-form-choice followup-form-choice--compact"
                  [checked]="isBooleanAnswer(idx, question.patientCallQuestionId, 'false')"
                  (ionChange)="onBooleanAnswerChange(idx, question.patientCallQuestionId, 'false', $event.detail.checked)"
                  labelPlacement="end"
                  alignment="center"
                  justify="start"
                >
                  No
                </ion-checkbox>
              </div>
            </ng-container>
          </div>
        </div>
      </ion-item>

      <ng-container *ngIf="question.patientQuestionTypeLabel == 'rating'">
        <div class="custom-question-container">
          <ion-label class="patient-call-question-label">
            {{ question.patientCallQuestion }}
          </ion-label>
          <ion-item class="patient-call-question-container call-question rating">
            <div class="rating-container">
              <ion-icon
                *ngFor="let star of [1, 2, 3, 4, 5]; let i = index"
                name="star"
                [class.filled]="isStarFilled(i + 1, question.patientCallQuestionId)"
                (click)="setRating(question.patientCallQuestionId, i + 1)"
              >
              </ion-icon>
            </div>
          </ion-item>
        </div>
      </ng-container>
      <ng-container *ngIf="question.patientQuestionTypeLabel == 'textarea'">
        <div class="custom-question-container">
          <ion-label class="patient-call-question-label">
            {{ question.patientCallQuestion }}
          </ion-label>
          <ion-item class="patient-call-question-container call-question">
            <ion-textarea
              formControlName="{{ question.patientCallQuestionId }}"
              [spellcheck]="true"
              [attr.spellcheck]="'true'"
              autocomplete="on"
              autocorrect="on"
              autocapitalize="sentences"
            ></ion-textarea>
          </ion-item>
        </div>
      </ng-container>
    </div>
  </ion-list>
</form>
